import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import { FC } from 'react';
import { Row } from './Row';
import { Trip } from '../../models/workday';
import {
  Box,
  Collapse,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import FiberManualRecord from '@mui/icons-material/FiberManualRecord';
import { InfoCard, InfoCardContent } from '../InfoCard/InfoCard';
import { ServiceCard, ServiceCardContent } from '../ServiceCard/ServiceCard';
import { ReportProblemOutlined } from '@mui/icons-material';
import { IconType } from '../../enums/IconType';
import { withStyles } from '@mui/styles';
import { SxProps } from '@mui/system';

interface Props {
  rows: RowData[];
  trip: Trip;
}

export type RowData = {
  icon: IconType;
  text: string;
  arrivalTime: string;
  departureTime: string;
  trpptFac?: string;
  trpptTpNote?: string;
  ttpNoteText?: string;
  serviceMessage?: string;
  loadTime?: number;
};

const classes: SxProps = {
  header: {
    justifyContent: 'space-between',
  },
  iconSmall: {
    fontSize: 8,
    minWidth: 10,
  },
  iconLarge: {
    fontSize: 14,
  },
  itemSmall: {
    padding: 0.5,
    display: 'inline',
  },
  items: {
    paddingLeft: 2.3,
  },
};

const BigListItemText = withStyles({
  primary: {
    fontSize: '18px',
  },
})(ListItemText);

export const CollapsibleList: FC<Props> = ({ rows, trip }) => {
  const showTTPNotesAtStart = rows.every((i) => i.ttpNoteText === '');
  const showTripPointServiceMessageNotification = !rows.every(
    (i) => i.serviceMessage === '',
  );

  const [open, setOpen] = useState(!showTTPNotesAtStart);
  const toggleOpen = () => setOpen((prev) => !prev);

  const moreThanTwoItems = rows.length > 2;

  const items = rows.map((row, i, arr) => (
    <Row
      key={row.departureTime + i}
      row={row}
      small={i !== 0 && i !== arr.length - 1}
    />
  ));

  if (trip.TrpRouteTransdevSpecial.includes('Tomkör'))
    trip.TrpRouteTransdevSpecial = 'Tomkörning';
  else if (trip.TrpRouteTransdevSpecial.includes('Inkörn'))
    trip.TrpRouteTransdevSpecial = 'Inkörning';
  else if (trip.TrpRouteTransdevSpecial.includes('Utkörn'))
    trip.TrpRouteTransdevSpecial = 'Utkörning';

  return (
    <>
      <ListItem
        button={moreThanTwoItems as any} //https://github.com/mui-org/material-ui/issues/14971
        dense
        sx={classes.header}
        onClick={toggleOpen}
      >
         {trip.TripIsEu && (
              <img
                style={{ width: '30px', marginRight: '5px' }}
                src="/assets/eu-flag.jpg"
                alt="EU"
              />
            )}
        <BigListItemText
          primary={
            isNaN(Number(trip.TrpRouteTransdevSpecial))
              ? trip.TrpRouteTransdevSpecial
              : `Linje ${trip.TrpRouteTransdevSpecial} - Tur ${trip.TrpNumber}`
          }
        />

        {showTripPointServiceMessageNotification === true && (
          <ReportProblemOutlined fontSize="medium" />
        )}

        {moreThanTwoItems && (
          <ListItemIcon>{open ? <ExpandLess /> : <ExpandMore />}</ListItemIcon>
        )}
      </ListItem>

      {trip.TripServiceMessage! && (
        <ServiceCard>
          <ServiceCardContent serviceMessage={trip.TripServiceMessage} />
        </ServiceCard>
      )}

      {trip.NteText! && (
        <InfoCard>
          <InfoCardContent comment={trip.NteText} icon={IconType.Info} />
        </InfoCard>
      )}

      {trip.NteText2! && (
        <Box py={1}>
          <InfoCard>
            <InfoCardContent comment={trip.NteText2} icon={IconType.Info} />
          </InfoCard>
        </Box>
      )}

      {trip.TravelDuties! && (
        <Box py={1}>
          <InfoCard>
            <InfoCardContent
              comment={trip.TravelDuties}
              icon={IconType.People}
            />
          </InfoCard>
        </Box>
      )}

      {items[0]}
      <Collapse in={open}>{items.slice(1, -1)}</Collapse>
      <Collapse in={!open} sx={classes.items}>
        {items.slice(0, -2).map((_, i) => {
          return (
            <ListItem key={i} sx={classes.itemSmall}>
              <ListItemIcon sx={classes.iconSmall}>
                <FiberManualRecord fontSize={'inherit'} />
              </ListItemIcon>
            </ListItem>
          );
        })}
      </Collapse>
      {items.slice(-1)}
    </>
  );
};
